import { Skeleton } from '@/components/ui/skeleton';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { AdminUser } from '@/types/admin.model';
import { Link } from 'react-router-dom';
import { RoleBadge, StatusBadge } from './UserBadges';
import { UserActionsMenu } from './UserActionsMenu';

interface Props {
  users: AdminUser[];
  isLoading: boolean;
  onActionDone: () => void;
}

const formatDate = (value: string | null) =>
  value ? new Date(value).toLocaleDateString('es-AR') : '—';

export const UsersTable = ({ users, isLoading, onActionDone }: Props) => {
  if (isLoading) {
    return (
      <div className="space-y-2">
        {Array.from({ length: 8 }).map((_, index) => (
          <Skeleton key={index} className="h-12" />
        ))}
      </div>
    );
  }

  if (users.length === 0) {
    return (
      <p className="py-10 text-center text-sm text-gray-500">
        No se encontraron usuarios.
      </p>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Nombre</TableHead>
          <TableHead>Email</TableHead>
          <TableHead>Rol</TableHead>
          <TableHead>Estado</TableHead>
          <TableHead>Registro</TableHead>
          <TableHead className="w-12" />
        </TableRow>
      </TableHeader>
      <TableBody>
        {users.map((user) => (
          <TableRow key={user.pk}>
            <TableCell>
              <Link
                to={`/admin/usuarios/${user.pk}`}
                state={{ user }}
                className="font-medium text-blue-700 hover:underline"
              >
                {user.name || '—'}
              </Link>
            </TableCell>
            <TableCell className="text-gray-600">{user.email}</TableCell>
            <TableCell>
              <div className="flex flex-wrap gap-1">
                {(user.roles ?? []).map((role) => (
                  <RoleBadge key={role} role={role} />
                ))}
              </div>
            </TableCell>
            <TableCell>
              <StatusBadge user={user} />
            </TableCell>
            <TableCell className="text-gray-600">{formatDate(user.createdDate)}</TableCell>
            <TableCell>
              <UserActionsMenu user={user} onDone={onActionDone} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
